import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminShell from './AdminShell';
import { api } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';
import { STEPS } from './workflow/shared';

const AdminWorkflowNew = () => {
  const [topic, setTopic] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const start = async (e) => {
    e.preventDefault();
    if (!topic.trim()) return;
    setBusy(true);
    try {
      const res = await api.post('/admin/workflows', { topic: topic.trim() });
      navigate(`/admin/workflows/${res.data.id}`);
    } catch (err) {
      toast({ title: 'Could not start workflow', description: err.response?.data?.detail || '', variant: 'destructive' });
      setBusy(false);
    }
  };

  return (
    <AdminShell title="New post with AI workflow">
      <button onClick={() => navigate('/admin/blog')} className="btn-link mb-4">
        <ArrowLeft className="w-4 h-4" /> Back to posts
      </button>
      <form onSubmit={start} className="bg-white rounded-2xl border border-[var(--line-2)] p-8 max-w-2xl">
        <div className="text-[11px] uppercase tracking-wider text-ink-3">Blog topic</div>
        <p className="text-sm text-ink-2 mt-1 mb-4">
          Start with a rough topic. The workflow will research keywords, analyse intent, draft with AI, and hand the article to your team for review before it is published.
        </p>
        <Input
          autoFocus
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          placeholder="e.g. How to measure executive briefing ROI"
          className="rounded-lg border-[var(--line-2)] h-12 text-base"
          data-testid="workflow-topic-input"
        />
        <div className="mt-6 flex items-center justify-between">
          <div className="text-xs text-ink-3">{STEPS.length} steps · progress is saved automatically</div>
          <button type="submit" disabled={busy || !topic.trim()} className="btn-primary disabled:opacity-60" data-testid="workflow-start-btn">
            {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Starting…</> : <>Start workflow <ArrowRight className="w-4 h-4" /></>}
          </button>
        </div>
      </form>
    </AdminShell>
  );
};

export default AdminWorkflowNew;
